import { getAdDeviceType } from '../../../client'
import { AdS, IItem, IPageMeta, ITag } from '../../../types'
import { ILevels } from '../Models/PlayerModels'
import { playerConfig } from './constants'
import { utils } from './utils'
import { getParameterByName } from '../../../utils'

export interface ICustParams {
  dxu: string
  dxseg: string
  platform: 'desktop' | 'mobile' | 'webview_app'
  type_of_page: IPageMeta['pageType'] | string
  level1: IPageMeta['levels']['level_1_eng']
  level2: IPageMeta['levels']['level_2_eng']
  level3: IPageMeta['levels']['level_3_eng']
  level4: IPageMeta['levels']['level_4_eng']
  level5: IPageMeta['levels']['level_5_eng']
  level6: IPageMeta['levels']['level_6_eng']
  tag: string
  view: string
  reshet: string
  environment: string
  bundleid: string
}

export const dfpUtils = (() => {
  return {
    DFPParams: () => {
      return {
        platform_key: 'platform',
        platform_value: !utils.isMobile()
          ? 'desktop'
          : playerConfig.inWebView
          ? 'webview_app'
          : 'mobile',
      }
    },

    urlToDfp: (url: string) => {
      const res = url.replace(/\//g, ' ').trim()
      return res === '' ? 'Hp' : res
    },

    geAssetKey: (country: string, videoRef: string) => {
      const ASEET_KEY = playerConfig.DFPParams.ASEET_KEY
      if (videoRef === 'stream_reshet_live1_token') {
        return ASEET_KEY['Token']
      } else {
        const location = country === 'Israel' ? 'Israel' : 'Global'
        const site_val = 'tv'
        const device = playerConfig.inWebView
          ? 'a'
          : !utils.isMobile()
          ? 'd'
          : 'm'
        return ASEET_KEY[location][site_val][device + '_key']
      }
    },

    getCustParams: ({
      pageType,
      levels,
      DFPType,
      pageViewedInDay,
      item,
      googlePal,
      referenceId,
      assetId,
      katuraId,
      environment = 'prod',
    }: {
      pageType: string
      levels: ILevels
      DFPType: string
      pageViewedInDay: number
      item: IItem | undefined
      googlePal?: string
      referenceId?: string | null
      assetId?: string | null
      katuraId?: string | null
      environment: string
    }) => {
      const DFP_PARAMS = dfpUtils.DFPParams()
      let tagVal = ''
      if (item !== undefined) {
        tagVal = utils.getParamsString(item.tags)
        tagVal = tagVal.replace(/,/g, '%26')
      }
      const adUnitObj = {
        url: window.location.pathname,
        environment: environment,
        key: 'reshet',
      }

      const keyValuesDFP = [
        { key: adUnitObj.key, value: dfpUtils.urlToDfp(adUnitObj.url) },
        { key: DFP_PARAMS.platform_key, value: DFP_PARAMS.platform_value },
        { key: 'environment', value: environment },
        { key: 'type_of_page', value: pageType },
        { key: 'bundleid', value: 'il.co.13tv' },
        {
          key: 'level1',
          value: levels.level_1_eng ? levels.level_1_eng : null,
        },
        {
          key: 'level2',
          value: levels.level_2_eng ? levels.level_2_eng : null,
        },
        {
          key: 'level3',
          value: levels.level_3_eng ? levels.level_3_eng : null,
        },
        {
          key: 'level4',
          value: levels.level_4_eng ? levels.level_4_eng : null,
        },
        // {
        //   key: 'level5',
        //   value: levels.level_5_eng ? levels.level_5_eng : null,
        // },
        // {
        //   key: 'level6',
        //   value: levels.level_6_eng ? levels.level_6_eng : null,
        // },
        { key: 'tag', value: tagVal },
      ]

      const idxsegvalue = localStorage.getItem(
        'dmp-publisher-prevDefinitionsIds'
      )
      if (idxsegvalue) {
        keyValuesDFP.push({
          key: 'dxseg',
          value: idxsegvalue,
        })
      }
      const dmpid = localStorage.getItem('dmp-publisher-dmpid')
      if (dmpid) {
        keyValuesDFP.push({
          key: 'dxu',
          value: dmpid,
        })
      }
      if (googlePal) {
        keyValuesDFP.push({
          key: 'pal',
          value: googlePal,
        })
      }

      if (
        pageViewedInDay &&
        pageViewedInDay <
          playerConfig.fakeWindow.siteConfig.adds.dayViewMaxCount
      ) {
        keyValuesDFP.push({ key: 'VIEW', value: 'view' + pageViewedInDay })
      }
      if (referenceId) {
        keyValuesDFP.push({ key: 'ref', value: referenceId })
      }
      if (assetId) {
        keyValuesDFP.push({ key: 'assetId', value: assetId })
      }
      if (katuraId) {
        keyValuesDFP.push({ key: 'katuraId', value: katuraId })
      }

      const length = keyValuesDFP.length
      let dfpstr = '',
        keyVal,
        val
      for (const param in keyValuesDFP) {
        // eslint-disable-next-line no-prototype-builtins
        if (keyValuesDFP.hasOwnProperty(param)) {
          keyVal = keyValuesDFP[param].key
          val = keyValuesDFP[param].value

          let equal = '%3D',
            ampersand = '%26',
            comma = '%2C'

          if (DFPType === 'midrollLive') {
            equal = '='
            ampersand = '&'
            comma = ','
          }

          if (keyVal === 'permutive' && val) {
            val = val.replace(/[[\]]+/g, '')
            val = val.replace(/,/g, comma)
          }

          dfpstr =
            dfpstr +
            keyVal +
            equal +
            val +
            (length === +param + 1 ? '' : ampersand)
        }
      }
      return dfpstr
    },
    getAdVideo: ({
      pagetypeMeta,
      pageType,
      adType,
      levels,
      pageViewedInDay,
      item,
      googlePal,
      referenceId,
      assetId,
      katuraId,
      environment = 'prod',
    }: {
      pagetypeMeta: string
      pageType: string
      adType: string
      levels: ILevels
      pageViewedInDay: number
      item?: IItem
      googlePal?: string
      referenceId: string | null
      katuraId?: string | null
      assetId?: string | null
      environment: string
    }) => {
      const ADS_VIDEO = playerConfig.DFPParams.ADS_VIDEO['tv']
      const device = playerConfig.inWebView
        ? 'a'
        : !utils.isMobile()
        ? 'd'
        : 'm'
      const ad = adType ? '_' + adType : ''
      const VMAPStr = device + '_' + pageType + ad
      const custParams = dfpUtils.getCustParams({
        pageType: pagetypeMeta,
        levels,
        DFPType: adType,
        pageViewedInDay,
        item,
        googlePal,
        referenceId,
        assetId,
        katuraId,
        environment,
      })

      return ADS_VIDEO[VMAPStr] + '&cust_params=' + custParams
    },

    AdVidDur: (duration: number) =>
      'video_' + Math.floor(duration / (60 * 3)) * 3,

    parseAdsIntoCollection: (vmapUrl: string) => {
      const parser = new DOMParser()
      const ads: AdS[] = []

      return fetch(vmapUrl)
        .then(result => result.text())
        .then(data => {
          const xmlDoc = parser.parseFromString(data, 'application/xml')
          const prerollTags = xmlDoc.getElementsByTagName('Preroll')

          for (let i = 0; i < prerollTags.length; i += 2) {
            const adTag = prerollTags[i].getElementsByTagName('Ad')[0]
            if (adTag) {
              const adContent = adTag.textContent?.trim() || null
              adContent && ads.push({ preroll: { ad: adContent } })
            }
          }

          const midrollTags = xmlDoc.getElementsByTagName('Midroll')
          const offsetTime = parseInt(getParameterByName('vmap_offset_time'))
          for (let i = 0; i < midrollTags.length; i++) {
            const timeOffset = midrollTags[i].getAttribute('timeOffset')
            const adTag = midrollTags[i].getElementsByTagName('Ad')[0]
            if (adTag) {
              const adContent = adTag.textContent?.trim()
              adContent &&
                ads.push({
                  midroll: {
                    timeOffset: timeOffset
                      ? dfpUtils.timeStringToSeconds(
                          offsetTime && offsetTime > 0
                            ? '00:0' + offsetTime * (i + 1) + ':00'
                            : timeOffset
                        )
                      : null,
                    ad: adContent,
                  },
                })
            }
          }
          return ads
        })
    },
    parseVast: async () => {
      try {
        const ADS_VIDEO = playerConfig.DFPParams.ADS_VIDEO
        const site_val = 'reels'
        const device = playerConfig.inWebView
          ? 'a'
          : !utils.isMobile()
          ? 'd'
          : 'm'
        const VMAPStr = device + '_' + 'reels'
        const debug = !(getParameterByName('debugDFP') === 'yes')
        const url = debug
          ? ADS_VIDEO[site_val][VMAPStr]
          : device === 'd'
          ? '/static/ad_reels_desktop.xml'
          : device === 'm'
          ? '/static/ad_reels_mobile.xml'
          : '/static/ad_reels_app.xml'

        // if need cust params need to add here
        const response = await fetch(url, {
          headers: { 'Content-Type': 'application/xml' },
        }).then(res => res.text())

        const parser = new DOMParser()
        const xmlDoc = parser.parseFromString(response, 'application/xml')

        // Check if the XML has <Ad> elements
        const ads = xmlDoc.getElementsByTagName('Ad')

        if (ads.length === 0) {
          return {
            hasAds: false,
            error: 'No ads found',
          }
        }

        // Find the first <MediaFile> with a playable video
        const mediaFiles = xmlDoc.getElementsByTagName('MediaFiles')
        let videoUrl = ''
        if (!mediaFiles) {
          return {
            hasAds: false,
            error: 'No media file found',
          }
        }
        const mediaFile = mediaFiles[0].getElementsByTagName('MediaFile')[0]
        if (mediaFile) {
          const video = mediaFile.textContent?.trim() || null
          if (video) {
            videoUrl = video
          } else {
            return {
              hasAds: false,
              error: 'No video found',
            }
          }
        } else {
          return {
            hasAds: false,
            error: 'No media file found',
          }
        }

        // Find duration (return in seconds)
        const durationNode = xmlDoc.querySelector('Duration')
        let duration = 0
        if (durationNode && durationNode.textContent) {
          const durationText = durationNode.textContent.trim()
          const parts = durationText.split(':').map(Number)
          if (parts.length === 3) {
            duration = parts[0] * 3600 + parts[1] * 60 + parts[2]
          }
        }

        // Find all Tracking events
        const trackingEvents: { [key: string]: string } = {}
        xmlDoc.querySelectorAll('Tracking').forEach(node => {
          const event = node.getAttribute('event')
          if (node.textContent) {
            const url = node.textContent.trim()
            if (event) {
              trackingEvents[event] = url
            }
          }
        })

        // Find the ClickThrough URL
        const VideoClicks = xmlDoc.getElementsByTagName('VideoClicks')
        const ClickThrough =
          VideoClicks[0].getElementsByTagName('ClickThrough')[0]
        let videoUrlClick = ''
        if (ClickThrough) {
          const urlVast = ClickThrough.textContent?.trim() || null
          videoUrlClick = urlVast ?? ''
        }

        // Find Loaded Ad Tracking
        const video_ad_loaded = xmlDoc.querySelectorAll(
          'Extension[type="video_ad_loaded"]'
        )
        video_ad_loaded.forEach(extension => {
          const customTracking = extension.querySelector('CustomTracking')
          if (customTracking) {
            const loadedTracking = customTracking.querySelector(
              'Tracking[event="loaded"]'
            )
            if (loadedTracking && loadedTracking.textContent) {
              trackingEvents['loaded'] = loadedTracking.textContent.trim()
            }
          }
        })

        // Find tracking events
        const trackings: string[] = []
        xmlDoc.querySelectorAll('Tracking').forEach(node => {
          if (node.textContent) {
            trackings.push(node.textContent.trim())
          }
        })

        return {
          hasAds: true,
          data: {
            url: videoUrlClick,
            duration,
            video: videoUrl,
            trackings: trackingEvents,
          },
          error: null,
        }
      } catch (error) {
        console.error('Error parsing VAST:', error)
        return { hasAds: false, error: 'error' }
      }
    },

    timeStringToSeconds: (timeString: string) => {
      if (timeString) {
        const [hours, minutes, seconds] = timeString.split(':').map(Number)
        return hours * 3600 + minutes * 60 + seconds
      }
      return null
    },

    buildCustParams: ({
      pageType,
      levels,
      route,
      tags,
      adTargetEnv,
      pageViewInDay,
    }: {
      pageType: IPageMeta['pageType'] | undefined | string
      levels: IPageMeta['levels'] | undefined
      route?: string
      tags?: ITag[] | undefined
      adTargetEnv?: string
      pageViewInDay: number
    }) => {
      const cust_params = {
        bundleid: 'il.co.13tv',
      } as ICustParams
      cust_params.platform =
        getAdDeviceType() === 'desktop'
          ? 'desktop'
          : getAdDeviceType() === 'mobile'
          ? 'mobile'
          : 'webview_app'
      pageType && (cust_params.type_of_page = pageType)
      levels?.level_1_eng && (cust_params.level1 = levels.level_1_eng)
      levels?.level_2_eng && (cust_params.level2 = levels.level_2_eng)
      levels?.level_3_eng && (cust_params.level3 = levels.level_3_eng)
      levels?.level_4_eng && (cust_params.level4 = levels.level_4_eng)
      // levels?.level_5_eng && (cust_params.level5 = levels.level_5_eng)
      // levels?.level_6_eng && (cust_params.level6 = levels.level_6_eng)

      if (tags) {
        cust_params.tag = tags
          .filter(tag => tag)
          .map(tag => tag.name)
          .join(',')
      }

      if (pageViewInDay < 5) {
        cust_params.view = pageViewInDay.toString()
      }

      const routeItems = route
        ?.split('?')[0]
        .split('/')
        .filter(p => p !== '')
      if (routeItems && routeItems.length > 0) {
        cust_params.reshet = `${routeItems
          .slice(1, routeItems.length)
          .join(' ')}`
      }

      if (adTargetEnv) {
        cust_params.environment = adTargetEnv
      }

      const prevDefinitionsIds = localStorage.getItem(
        'dmp-publisher-prevDefinitionsIds'
      )
      if (prevDefinitionsIds) {
        cust_params.dxseg = prevDefinitionsIds
      }
      const dmpid = localStorage.getItem('dmp-publisher-dmpid')
      if (dmpid) {
        cust_params.dxu = dmpid
      }

      return cust_params
    },
    setAdTargeting: ({
      pageType,
      levels,
      route,
      tags,
      AD_TARGET_ENV,
      pageViewInDay,
    }: {
      pageType: IPageMeta['pageType'] | string | undefined
      levels: IPageMeta['levels'] | undefined
      route: string
      tags?: ITag[] | undefined
      AD_TARGET_ENV?: string
      pageViewInDay: number
    }) => {
      if (!window.googletag) {
        console.warn('googletag is not defined')
        return
      }

      const cust_params = dfpUtils.buildCustParams({
        pageType,
        levels,
        route,
        tags,
        adTargetEnv: AD_TARGET_ENV,
        pageViewInDay,
      })
      if (!cust_params) {
        return
      }

      window.googletag.cmd.push(() => {
        window.googletag.pubads().clearTargeting()

        Object.entries(cust_params).forEach(([key, value]) => {
          window.googletag.pubads().setTargeting(key, value)
        })
      })
    },
  }
})()
